import { render, staticRenderFns } from "./ExternalServices.vue?vue&type=template&id=180162a0"
import script from "./ExternalServices.vue?vue&type=script&lang=js"
export * from "./ExternalServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports